import { render, staticRenderFns } from "./Podium.vue?vue&type=template&id=6222cea4&scoped=true&"
import script from "./Podium.vue?vue&type=script&lang=js&"
export * from "./Podium.vue?vue&type=script&lang=js&"
import style0 from "./Podium.vue?vue&type=style&index=0&id=6222cea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222cea4",
  null
  
)

component.options.__file = "Podium.vue"
export default component.exports